import { PageHeader } from "@ant-design/pro-components";
import React from "react";
import { Link } from "react-router-dom";
import "./style.less";

const PPPageHeader = ({ title, ...restProps }) => {
  const itemRender = (route, params, routes, paths) => {
    const last = routes.indexOf(route) === routes.length - 1;
    return last ? (
      <span>{route.title}</span>
    ) : (
      <Link to={route.to ? route.to : route.path}>{route.title}</Link>
    );
  };

  if (restProps.breadcrumb) restProps.breadcrumb.itemRender = itemRender;

  return <PageHeader title={title} className="pppage_header" {...restProps} />;
};

export default PPPageHeader;
